import { BorderedStack } from '@domains/subscription/priv/components/BorderedStack'
import { styled, Typography, useTheme } from '@mui/material'

type SettingBoxProps = {
  title: string
  onClick: () => void
  active: boolean
  focused: boolean
}

export const ListItemBox = ({ title, onClick, active, focused }: SettingBoxProps) => {
  const { palette } = useTheme()

  return (
    <BorderedStackWithHover
      direction="row"
      style={{ cursor: 'pointer' }}
      onClick={onClick}
      data-focused={focused}
      sx={{
        bgcolor: palette.common.white,
        padding: 2,
        borderRadius: 2,
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography data-testid="list-item-title" variant="p2Medium" color={active ? 'textPrimary' : 'textSecondary'}>
        {title}
      </Typography>
    </BorderedStackWithHover>
  )
}

const BorderedStackWithHover = styled(BorderedStack)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&[data-focused="true"]': {
    backgroundColor: theme.palette.action.hover,
  },
}))
